import useBSSLogger from "../hooks/useBSSLogger"

const {logger} = useBSSLogger();


export default (prevProps, nextProps) => {

    
    const prev = {
        //values: prevProps.methods.getValues(),
        value: prevProps.methods.getValues(prevProps.name),
        disabilitaByDep: prevProps.disabilitaByDep
    }
    const next = {
        //values: nextProps.methods.getValues(),
        value: nextProps.methods.getValues(nextProps.name),
        disabilitaByDep: nextProps.disabilitaByDep
    }
    
    const usingMemoized = prev.value === next.value && 
        prev.disabilitaByDep === next.disabilitaByDep;


    logger.debug("memo field comparator - richiesto rerendering", prevProps.name, !usingMemoized)

    return usingMemoized;
    
}